import { API_endpoints } from "../config";

export const setEmploy = async (data: { first_name: string; last_name: string; email: string; password: string; is_admin: boolean; is_statistic: boolean; }) => {
    try {
        const response = await fetch(API_endpoints.setEmploy, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({ ...data }),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Fehler beim Festlegen der FAQ-Anfrage.");
        }

        const responseData = await response.json();
        return responseData;
    } catch (error) {
        console.error("Fehler beim Festlegen der FAQ-Anfrage:", error);
        throw error;
    }
};
